import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { getFirestoreDb } from '@/lib/firebase';
import {
  isJotformContactReady,
  isJotformEmailReady,
  submitJotformContact,
  submitJotformEmail,
} from '@/services/jotformSubmit';

export type EmailLeadSource =
  | 'homepage_checklist'
  | 'blog_newsletter'
  | 'footer_newsletter';

const CONTACT_KEYS = [
  'language',
  'first_name',
  'last_name',
  'email',
  'phone',
  'business_name',
  'industry',
  'funding_amount',
  'years_in_business',
  'preferred_plan',
  'notes',
] as const;

function pickContactFields(
  fields: Record<string, string>
): Record<string, string> {
  const out: Record<string, string> = {};
  for (const k of CONTACT_KEYS) {
    const v = fields[k];
    if (v !== undefined && v !== null && String(v).trim() !== '') {
      out[k] = String(v).trim();
    }
  }
  return out;
}

export type SubmitLeadOptions = { recaptchaVerified?: boolean };

export async function submitEmailLead(
  email: string,
  source: EmailLeadSource,
  options?: SubmitLeadOptions
): Promise<void> {
  const tasks: Promise<void>[] = [];
  const normalized = email.trim().toLowerCase();

  if (isJotformEmailReady()) {
    tasks.push(
      submitJotformEmail({ email: normalized, source }).catch((e) => {
        console.warn('[Kailac] Jotform email:', e);
      })
    );
  }

  const db = getFirestoreDb();
  if (db) {
    tasks.push(
      addDoc(collection(db, 'kailac_email_leads'), {
        email: normalized,
        source,
        recaptchaVerified: Boolean(options?.recaptchaVerified),
        createdAt: serverTimestamp(),
      }).then(() => {})
    );
  } else if (!isJotformEmailReady()) {
    console.warn('[Kailac] Ni Jotform ni Firebase: no se guardó el email.');
  }

  await Promise.all(tasks);
}

export async function submitContactApplication(
  fields: Record<string, string>,
  options?: SubmitLeadOptions
): Promise<void> {
  const picked = pickContactFields(fields);
  const tasks: Promise<void>[] = [];

  if (isJotformContactReady()) {
    tasks.push(
      submitJotformContact(picked).catch((e) => {
        console.warn('[Kailac] Jotform contacto:', e);
      })
    );
  }

  const db = getFirestoreDb();
  if (db) {
    tasks.push(
      addDoc(collection(db, 'kailac_contact_applications'), {
        ...picked,
        recaptchaVerified: Boolean(options?.recaptchaVerified),
        createdAt: serverTimestamp(),
      }).then(() => {})
    );
  } else if (!isJotformContactReady()) {
    console.warn('[Kailac] Ni Jotform ni Firebase: no se guardó la solicitud.');
  }

  await Promise.all(tasks);
}
